import React, { useState } from "react";
import "./FAQ.css";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";


const FAQ = () => {
interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

const aboutFinsallFaqs: FAQItem[] = [
  {
    question: "What is Finsall ?",
    answer: (
      <>
        Finsall - Financing Insurance for All - was conceptualized the solve the
        budget constraints that customers face at the time of making
        premium payment. Finsall improves affordability of insurance policies for
                                            customers who are unable to pay the entire insurance premium
                                            amount upfront. Finsall provides a technology platform and support to
                                            insurers and insurance intermediaries to finance any type of general
                                            insurance policy for both retail and SME customers.
      </>
    ),
  },

  {
    question:
      "How can Finsall help in improving sales from existing customers?",
    answer: (
      <>
        Your existing customers typically would understand the need of insurance and
                                            value it already. However, because of their budget
                                            constraints they might still be under-insured. Those customers can now be
                                            provided appropriate insurance as they would need to pay
                                            much lesser amount upfront.<br/>Providing premium financing to your existing
                                            customers will also help in improving retention as in
                                            the subsequent years the customers will request for similar services.
      </>
    ),
  },

  {
    question:
      "How can Finsall help in capturing new market and products?",
    answer: (
      <>
        Finsall's approach of helping customers meet their premium payment
                                            obligation is an innovative approach as it addresses the initial
                                            hick-ups of the proposer. Insurance premium financing can be very helpful in
                                            attracting new customers segments, where certain types
                                            of insurance products can now become relevant because of financing
                                            options.<br/>
                                            Insurance premium financing specially helps for products which the
                                            customer’s realize the need of insurance but still don’t budget
                                            for it. Please get in touch with us to know how you can target new customer
                                            segments and products.
      </>
    ),
  },

  {
    question:
      "Does Finsall sell or suggest insurance to customers?",
    answer: (
      <>
        Finsall will never sell insurance policies. The intent is simple we want to
                                            be the trusted
                                            partner with the existing insurance sales channels and not become a
                                            competition. In accordance to the above, we have
                                            not taken any license (agency / broking) and in future also we will only
                                            concentrate on financing of insurance.
      </>
    ),
  },
];

const customerFaqs: FAQItem[] = [
  {
    question: "Can customer directly approach Finsall?",
    answer: (
      <>
        Yes, we will be happy to answer any questions for our existing or
                                            prospective customers. Finsall will support customers by educating
                                            them of the financing process, conditions for financing, documentation
                                            required etc. However, we will not be able to provide any help
                                            in selecting insurer or insurance products.
      </>
    ),
  },

  {
    question:
      "What is the shortest processing time for an application?",
    answer: (
      <>
        In an integrated journey the customers can complete the whole process easily
                                            in under 3 minutes. As our process is completely
                                            automated and digital, there is no hindrance or waiting time for the
                                            customers.
      </>
    ),
  },

  {
    question:
      "What is the overall process for premium financing?",
    answer: (
      <>
        Finsall provides a bespoke solution for the insurance industry to finance
                                            insurance policies, the process is designed in a way that
                                            it is easy and requires minimal effort. Following are high level steps for
                                            premium financing <br/>
                                            <ul>
                                                <li>Eligibility check</li>
                                                <li>Customer Application</li>
                                                <li>Upload documents (wherever required)</li>
                                                <li>Complete required compliances (completely digital)</li>
                                                <li>Disbursal to the Insurance Company and policy issuance</li>

                                            </ul>
      </>
    ),
  },
];

const intermediaryFaqs: FAQItem[] = [
  {
    question:
      "How can the progress of customer’s application be tracked?",
    answer: (
      <>
        The Intermediaries can track the progress of customer’s application, right
                                            from approval to all compliance steps. These steps can be tracked through my
                                            application
                                            section in Finsall app or web portal. This information can also be shared
                                            via real-time API updates.
      </>
    ),
  },

  {
    question:
      "How can documents be uploaded or re-uploaded?",
    answer: (
      <>
       Customer’s required documents can be uploaded or re-uploaded from the review
                                            section present in Finsall app or web portal.
      </>
    ),
  },

  {
    question:
      "Who can be contacted from Finsall if any assistance is required?",
    answer: (
      <>
        You can contact us through our business phone number:
        <br />
        <strong>18005705797</strong>
        <br />
        <br />
        Or via email:
        <br />
        <strong>info@finsall.com</strong>
      </>
    ),
  },

  {
    question:
      "Can the login credentials works on both Finsall application and Finsall web portal?",
    answer: (
      <>
        Yes, the same credentials work for both.
        <br />
        <br />
        The links are as follows:
        <ul>
          <li>
            <a
              href="https://finsall.com/finsall/#/login"
              target="_blank"
              rel="noreferrer"
            >
              Web Portal
            </a>
          </li>

          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.finsall"
              target="_blank"
              rel="noreferrer"
            >
              Finsall App
            </a>
          </li>
        </ul>
      </>
    ),
  },
];

const sidebarItems = [
  {
    id: "about-finsall",
    title: "About Finsall",
  },
  {
    id: "customers",
    title: "Customers",
  },
  {
    id: "intermediaries",
    title: "Intermediaries",
  },
];

const [activeSection, setActiveSection] =
  useState("about-finsall");

const [openAboutFaq, setOpenAboutFaq] =
  useState(0);

const [openCustomerFaq, setOpenCustomerFaq] =
  useState(0);

const [openIntermediaryFaq, setOpenIntermediaryFaq] =
  useState(0);

const scrollToSection = (id: string) => {
  setActiveSection(id);

  const element = document.getElementById(id);

  if (element) {
    const headerOffset = 120;

    const elementPosition =
      element.getBoundingClientRect().top +
      window.pageYOffset;

    const offsetPosition =
      elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

const renderAccordion = (
  faqs: FAQItem[],
  openIndex: number,
  setOpenIndex: React.Dispatch<React.SetStateAction<number>>
) => {
  return (
    <div className="faq-accordion">

      {faqs.map((faq, index) => (
        <div
          key={index}
          className="faq-item"
        >

          <button
            className={`faq-question ${
              openIndex === index ? "active" : ""
            }`}
            onClick={() =>
              setOpenIndex(
                openIndex === index ? -1 : index
              )
            }
          >
            <span>{faq.question}</span>

            <span className="faq-icon">
  {openIndex === index ? "⌃" : "⌄"}
</span>
          </button>

          {openIndex === index && (
            <div className="faq-answer">
              {faq.answer}
            </div>
          )}

        </div>
      ))}

    </div>
  );
};

return (
  <>

<title>Premium Finance FAQ and Insurance EMI Help</title>
<meta
  name="description"
  content="Get answers to common questions on premium finance, EMI payments, digital approval process and Finsall’s insurance financing solutions."
/>

    <Header />

    <div className="faq-page">

      <div className="faq-top-strip"></div>

      <section className="faq-section">

        <div className="faq-container">

          {/* LEFT SIDEBAR */}

          <aside className="faq-sidebar">

            {sidebarItems.map((item) => (
              <button
                key={item.id}
                className={`faq-sidebar-item ${
                  activeSection === item.id ? "active" : ""
                }`}
                onClick={() => scrollToSection(item.id)}
              >
                <span className="faq-sidebar-icon">
  ?
</span>

                <span>{item.title}</span>
              </button>
            ))}

          </aside>

          {/* RIGHT CONTENT */}

          <div className="faq-content">

            {/* =====================================
                ABOUT FINSALL
            ===================================== */}

            <section
              id="about-finsall"
              className="faq-category"
            >
              <h2>Premium Finance Frequently Asked Questions</h2>

              {renderAccordion(
                aboutFinsallFaqs,
                openAboutFaq,
                setOpenAboutFaq
              )}
            </section>

            {/* =====================================
                CUSTOMERS
            ===================================== */}

            <section
              id="customers"
              className="faq-category"
            >
              <h2>Customers</h2>

              {renderAccordion(
                customerFaqs,
                openCustomerFaq,
                setOpenCustomerFaq
              )}
            </section>

            {/* =====================================
                INTERMEDIARIES
            ===================================== */}

            <section
              id="intermediaries"
              className="faq-category"
            >
              <h2>Intermediaries</h2>

              {renderAccordion(
                intermediaryFaqs,
                openIntermediaryFaq,
                setOpenIntermediaryFaq
              )}
            </section>

          </div>

        </div>

      </section>

      <Footer />

    </div>
  </>
);

}

export default FAQ;